import React, { Component } from "react";
import Loading from "./../utils/Loading";

import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

import swal from "sweetalert";

export const ModalInformeTrimestral = (props) => {
    const toggle = () =>
      props.activarModalInformeTrimestral(props.modalInformeTrimestral);
  
    const {  modalInformeTrimestralStatus} = props;
    return (
      <Modal isOpen={modalInformeTrimestralStatus} toggle={toggle} size="lg" backdrop="static">
        <ModalHeader className="block-example border-bottom " toggle={toggle}>
          Cargar Informe Trimestral
        </ModalHeader>
  
        <ModalBody>
            <div className="row">
           <div className="form-group col-md-4">
            <label>Trimestre</label>
            <select className="form-control" onChange={(e)=>{
                      e.preventDefault();
                      props.seleccionarTrimestre(e.currentTarget.value);
                      }}>
                <option key="0" value="">--Seleccionar Trimestre--</option>
               {props.trimestres.map(trimestre=>(
                    <option key={trimestre.trimestreId}  value={trimestre.trimestreId}>{trimestre.nombre}</option>
               ))} 
            </select>
           </div>
           <div className="form-group col-md-8">
                  <label>Cargar Informe del Trimestre</label>
                  <input
                  id="inputpdf"
                    className="form-control text-dark"
                    type="file" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
                    name="file[]"
                    onChange= {
                      (e) => {
                          e.preventDefault();
                          ////////////////////////////////////////////////////////////
                          var fileInput = document.getElementById('inputpdf');
                          var filePath = fileInput.value;
                          var allowedExtensions = /(\.pdf|\.jpg|\.jpeg|\.png|\.doc|\.docx|\.xls|\.xlsx|\.ppt|\.pptx)$/i;
                          if (!allowedExtensions.exec(filePath)) {
                            swal("Error de tipo de archivo","Solo se permiten archivos: PDF, Excel, JPG, PNG, Word y PowerPoint","error");
                              fileInput.value = '';
                              return false;
                          } 
                          ///////////////////////////////////////////////
                          props.cargarInformeTrimestral(e);
                      }
                    }
                  />
                </div>
           </div>
         </ModalBody>
        <ModalFooter>
        <button
            className="btn btn-primary"
            onClick={(e)=>{
                e.preventDefault();
                props.guardarInformeTrimestral();
            }}
          >
            Guardar
          </button>
          <button
            className="btn btn-danger"
            onClick={(e) => {
              e.preventDefault();
              props.activarModalInformeTrimestral(props.modalInformeTrimestral);
            }}
          >
            Salir
          </button>
        </ModalFooter>
      </Modal>
    );
  };